import { toast } from "react-toastify";
import BlockIcon from "@mui/icons-material/Block"; // Icono desactivar
import CheckCircleIcon from "@mui/icons-material/CheckCircle"; // Icono activar
import { activateOrDeactiveUser } from "../../services/userServices";
import ConfirmDialog from "../../utils/ConfirmDialog";

export default function UserModalToggleStatus({
  handleClose,
  open,
  user,
  updateList,
}) {
  
  const handleToggleUser = async () => {
    try {
      const endpoint = user.active
        ? `/api/v1/users/${user.id}/deactivate`
        : `/api/v1/users/${user.id}/activate`;

      await activateOrDeactiveUser(endpoint)

      toast.success(
        user.active ? "Usuario desactivado" : "Usuario activado"
      );
      updateList();
    } catch (err) {
      toast.error("No se pudo actualizar el estado del usuario");
    }

    handleClose();
  };

  return (
    <ConfirmDialog
      open={open}
      handleClose={handleClose}
      onConfirm={handleToggleUser}
      title={user.active ? "Desactivar usuario" : "Activar usuario"}
      message={
        user.active
          ? "¿Está seguro que desea desactivar este usuario?"
          : "¿Está seguro que desea activar este usuario?"
      }
      confirmText={user.active ? "Desactivar" : "Activar"}
      confirmColor={user.active ? "error" : "success"}
      confirmIcon={user.active ? <BlockIcon /> : <CheckCircleIcon />}
    />
  );
}
